/**
 * Feature flag constants
 *
 * @desc JS counterpart of Feature.php class
 */
export const AA_ACCOUNT_COUPON_REDEEM = 'aa_account_coupon_redeem';
export const AA_ADDITIONAL_LOGIN = 'aa_additional_login';
export const AA_ADDONS = 'aa_addons';
export const AA_ANNUAL_PLAN = 'aa_annual_plan';
export const AA_DYNAMIC_AGREEMENT_COPY = 'aa_dynamic_agreement_copy';
export const AA_EDU = 'aa_edu';
export const AA_GIFT = 'aa_gift';
export const AA_PACKAGE_SWITCH = 'aa_package_switch';
export const AA_PAYPAL = 'aa_paypal';
export const AA_PURCHASE = 'aa_purchase';
export const AA_PURCHASE_REVIEW_SCREEN = 'aa_purchase_review_screen';
export const CBSN = 'cbsn';
export const ETL = 'etl';
export const LOCAL_LIVE_TV = 'local_live_tv';
export const MOVIES = 'movies';
export const MVPD = 'mvpd';
export const PIN_CONTROLS = 'pin_controls';
export const PRICE_WITH_ASTERISK = 'price_with_asterisk';
export const REGIONAL_SKUS = 'regional_skus';
export const RENDEZVOUS = 'rendezvous';
export const SHARED_PAYMENT_COMPONENT = 'shared_payment_component';
export const SHOW_INNER_PAGES = 'show_inner_pages';
export const SITE_SEARCH = 'site_search';
export const SPORTS_HQ = 'sports_hq';
export const TUNE_IN_INFO = 'tune_in_info';
export const TVE_GHOST_ACCOUNT = 'tve_ghost_account';
export const USER_PROFILE = 'user_profile';
export const PASSWORD_RESET_FLOW = 'password_reset_flow';
export const SHOWHIDE_PASSWORD = 'show_hide_password';
